import { useEffect, useState } from "react";

// Oct 16, 2026 · 10:00 Atlantic (ADT, UTC-3) = 9:00 Eastern (EDT)
export const LAUNCH_AT = Date.parse("2026-10-16T13:00:00Z");
export const LAUNCH_LABEL = "Oct 16 · 10am AST / 9am EST";

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

export const useCountdown = (target = LAUNCH_AT) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = target - now;
  return { done: left <= 0, ...parts(left) };
};

export const pad = (n) => String(n).padStart(2, "0");

// Visitor's own launch time, e.g. "That's 7am in Vancouver". Null when it matches the AST/EST label already shown.
export const localLaunch = () => {
  let tz;
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { return null; }
  if (!tz) return null;
  const d = new Date(LAUNCH_AT);
  const get = (opts) => new Intl.DateTimeFormat("en-CA", { timeZone: tz, ...opts }).format(d);
  const h24 = Number(get({ hour: "numeric", hourCycle: "h23" }));
  const min = Number(get({ minute: "numeric" }));
  const day = get({ month: "short", day: "numeric" }).replace(".", "");
  if (day === "Oct 16" && min === 0 && (h24 === 10 || h24 === 9)) return null;
  const h12 = h24 % 12 || 12;
  const time = `${h12}${min ? `:${pad(min)}` : ""}${h24 < 12 ? "am" : "pm"}`;
  const city = tz.includes("/") && !tz.startsWith("Etc/") ? tz.split("/").pop().replace(/_/g, " ") : null;
  return `That's ${time}${day !== "Oct 16" ? ` on ${day}` : ""} ${city ? `in ${city}` : "your time"}`;
};

export const useLocalLaunch = () => {
  const [label, setLabel] = useState(null);
  useEffect(() => { setLabel(localLaunch()); }, []);
  return label;
};

